// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/Header.tsx
// Version: v1.5.0
// Description: Header always shows for non-CMS pages, only hides if CMS explicitly sets header_menu_id=null

import { useMemo } from 'react';
import { useIsDesktop } from '../hooks/Breakpoints.tsx';
import { useLanguage } from '../lang/index.lang.tsx';
import { useNavigation, NavigationItem } from '../hooks/useNavigation.tsx';
import { usePageData } from '../hooks/usePageData.tsx';
import HeaderDesktop from './header/HeaderDesktop.tsx';
import HeaderMobile from './header/HeaderMobile.tsx';
import { getNavigationConfig, NavigationItem as StaticNavItem } from './header/navigationConfig.tsx';

const convertCmsToNavConfig = (items: NavigationItem[]): StaticNavItem[] => {
  return items.map(item => ({
    name: item.label,
    href: item.href || '#',
    hasDropdown: item.has_dropdown,
    dropdownType: item.dropdown_type as any,
  }));
};

const Header = () => {
  const isDesktop = useIsDesktop();
  const { t } = useLanguage();
  
  const pageData = usePageData();
  
  const { items: cmsItems, isLoading: menuLoading } = useNavigation({
    menuId: pageData.isLoading ? undefined : pageData.header_menu_id,
    menuName: pageData.isLoading ? 'header' : undefined
  });

  const staticConfig = useMemo(() => getNavigationConfig(t), [t]);

  const NAVIGATION_CONFIG = useMemo(() => {
    if (cmsItems.length > 0) {
      return convertCmsToNavConfig(cmsItems);
    }
    return staticConfig;
  }, [cmsItems, staticConfig]);

  // Header nur verstecken wenn CMS-Seite EXISTIERT und EXPLIZIT keinen Header will
  // Bei nicht-CMS-Seiten (404, statische Routen) → Header immer zeigen
  if (!pageData.isLoading && pageData.isPublished && pageData.slug && pageData.header_menu_id === null) {
    return null;
  }

  // Loading oder kein CMS-Eintrag → statische Config
  if ((pageData.isLoading || menuLoading) && cmsItems.length === 0) {
    return isDesktop ? (
      <HeaderDesktop navigationConfig={staticConfig} />
    ) : (
      <HeaderMobile navigationConfig={staticConfig} />
    );
  }

  return isDesktop ? (
    <HeaderDesktop navigationConfig={NAVIGATION_CONFIG} />
  ) : (
    <HeaderMobile navigationConfig={NAVIGATION_CONFIG} />
  );
};

export default Header;
